import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGlobalContext } from "../Contexts/GlobalContext";
import { hideNav } from "../Utlils";
import { FaKey, FaArrowRight } from "react-icons/fa";

const SecretKeyWarningBar = () => {
  const navigate = useNavigate();
  const { user, setSnackbar, organization } = useGlobalContext();
  const [shouldDisplay, setShouldDisplay] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (user && organization) {
        if (!organization.key && user._id) {
          setShouldDisplay(true);
        } else {
          setShouldDisplay(false);
        }
      }
    }, 1500);

    return () => clearTimeout(timer);
  }, [user?._id, organization?._id]);

  if (
    hideNav.some((data) => window.location.href.includes(data)) ||
    !shouldDisplay
  ) {
    return null;
  }

  return (
    <div className="w-full bg-blue-50 border-l-4 border-[#0226BE] rounded-md shadow-sm my-3">
      <div className="px-6 py-4 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 flex-1">
          <div className="flex-shrink-0">
            <FaKey className="text-[#0226BE]" size={20} />
          </div>
          <div className="flex-1">
            <h3 className="text-[#333] text-[14px] font-[600] mb-0.5">
              Secret Key Required
            </h3>
            <p className="text-[#666] text-[13px] font-[400]">
              Generate your organization's secret key to enable secure API access and integrations.
            </p>
          </div>
        </div>
        <button
          className="flex-shrink-0 bg-[#0226BE] text-white px-5 py-2 text-[13px] font-[500] rounded-md hover:bg-[#021ea8] transition-colors flex items-center gap-2 whitespace-nowrap"
          onClick={() => {
            if (user?.role === "admin") {
              navigate("/profile/redirects-and-keys");
            } else {
              setSnackbar({
                open: true,
                msg: "Only admin can add this details",
                severity: "warning",
              });
            }
          }}
        >
          Generate Key
          <FaArrowRight size={12} />
        </button>
      </div>
    </div>
  );
};

export default SecretKeyWarningBar;
